/** 主内容滚动容器 id：首页、MobileListRefresh、ModalBox ScrollToTop 共用 */
export const HOME_SCROLL_CONTAINER_ID = 'home-scroll-container';
